import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Toaster } from "sonner";
import { Nav } from "./Nav";
import { Footer } from "./Footer";
import { CookieBanner } from "./CookieBanner";
import { GlobeMark } from "./Logo";
import { ease } from "./motion";
import { useLenis, useRouteScroll } from "@/hooks/useSiteScroll";

const Intro = () => (
  <motion.div
    data-testid="intro-curtain"
    className="fixed inset-0 z-[80] bg-[#082F24] grain grid place-items-center"
    initial={{ clipPath: "inset(0 0 0% 0)" }}
    exit={{ clipPath: "inset(0 0 100% 0)" }}
    transition={{ duration: 1, ease }}
  >
    <motion.div initial={{ opacity: 0, scale: 0.8 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.8, ease }} className="flex flex-col items-center gap-5">
      <motion.div animate={{ rotate: 360 }} transition={{ duration: 1.6, ease }}><GlobeMark className="h-20 w-20" /></motion.div>
      <p className="font-mono-ega text-xs uppercase tracking-[0.4em] text-[#D4AF37]">Emerald Global Advisory</p>
    </motion.div>
  </motion.div>
);

export default function Layout() {
  const { pathname } = useLocation();
  const [intro, setIntro] = useState(true);
  useLenis();
  useRouteScroll();

  useEffect(() => { const t = setTimeout(() => setIntro(false), 1500); return () => clearTimeout(t); }, []);

  return (
    <div className="min-h-screen bg-[#FAF8F5]">
      <AnimatePresence>{intro && <Intro />}</AnimatePresence>
      <Nav />
      <main key={pathname}><Outlet /></main>
      <Footer />
      <CookieBanner />
      <Toaster position="top-center" richColors />
    </div>
  );
}
